import { render, staticRenderFns } from "./FlagProductModal.vue?vue&type=template&id=1157eb04&scoped=true&"
import script from "./FlagProductModal.vue?vue&type=script&lang=js&"
export * from "./FlagProductModal.vue?vue&type=script&lang=js&"
import style0 from "./FlagProductModal.vue?vue&type=style&index=0&id=1157eb04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1157eb04",
  null
  
)

export default component.exports